import React from 'react';

import { colorsPalette } from '../../theme';
import useStyles from './styles';

const LockIcon = (props) => {
  const color = props?.color || colorsPalette.white;
  const classes = useStyles()();
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
      color={color}
    >
      <path
        className={classes.element}
        d="M20,12a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2Z"
      />
      <path className={classes.element} d="M18,10H6V8A6,6,0,0,1,18,8Z" />
      <line className={classes.element} x1="12" y1="15.00001" x2="12" y2="17.00001" />
    </svg>
  );
};

export default LockIcon;
